// extracted by mini-css-extract-plugin
module.exports = {"backToTop":"backToTop_backToTop__qkrY7","fadeIn":"backToTop_fadeIn__EdaBk"};